export default __webpack_public_path__ + "static/media/hospital.f6e9a6e6.png";